type YouTubeOptions = {
  videoId: string;
  videoTitle: string;
};

type YouTube = {
  init: () => void;
};

const YouTube: YouTube = {
  init() {
    const videos: NodeListOf<HTMLElement> = document.querySelectorAll('[data-hook=youtubeVideo]');
    if (!videos.length) return;

    videos.forEach((video) => {
      if (!video.dataset.options) return;

      const videoOptions: YouTubeOptions = JSON.parse(video.dataset.options);
      if (!videoOptions.videoId) return;

      const iframeWrapper: HTMLElement | null = video.querySelector('[data-hook=youtubeVideoIframeWrapper]');
      const videoPlayButton: HTMLButtonElement | null = video.querySelector('[data-hook=youtubeVideoPlayButton]');

      videoPlayButton?.addEventListener('click', () => {
        if (!iframeWrapper) return;

        const iframe = document.createElement('iframe');
        iframe.setAttribute('src', `https://www.youtube.com/embed/${videoOptions.videoId}?autoplay=1&rel=0`);
        iframe.setAttribute('title', videoOptions.videoTitle);
        iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
        iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
        iframe.setAttribute('allowfullscreen', 'true');

        iframeWrapper.innerHTML = '';
        iframeWrapper.appendChild(iframe);
      });
    });
  },
};
export default YouTube;
